import alt from 'components/Dispatcher';

class EditScorecardActions {
  constructor() {
    this.generateActions('initializeForm', 'updateForm');
  }
}

export default alt.createActions(EditScorecardActions);
